import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const ProtectedRoute = ({ children, roles }) => {
    const { user, loading } = useAuth();
    if (loading || user === undefined) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="w-8 h-8 rounded-full border-2 border-primary/30 border-t-primary animate-spin" />
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (roles && !roles.includes(user.role) && user.role !== "super_admin") {
        return <Navigate to="/" replace />;
    }
    return children;
};

export default ProtectedRoute;
